export default "__VITE_ASSET__xe1qmT9U__"